import React from "react";

/**
 * PersonalInfoFields Component
 * Renders input fields for personal information (First Name, Last Name, Email, Phone) with validation feedback.
 * Props:
 *  - state: form state object
 *  - handleChange: input change handler
 */
const PersonalInfoFields = ({ state, handleChange }) => {
  // Helper function to render a single input field with validation tooltips
  const renderInputField = ({
    id,
    name,
    label,
    type = "text",
    value,
    error,
    required = false,
  }) => (
    <div className="col-lg-3">
      <div className="form-floating mb-4 position-relative">
        <input
          type={type}
          className={`form-control ${
            error ? "is-invalid" : value ? "is-valid" : ""
          }`}
          id={id}
          name={name}
          value={value}
          onChange={handleChange}
          required={required}
          placeholder=" "
          autoComplete="off"
        />
        <label htmlFor={id}>{label}</label>

        {/* Show error tooltip if validation fails */}
        {error && <div className="invalid-tooltip">{error}</div>}

        {/* Show success tooltip if field is valid */}
        {value && !error && (
          <div className="valid-tooltip">{`${label} is valid`}</div>
        )}
      </div>
    </div>
  );

  return (
    <div className="row">
      <div className="col-12">
        <p>Contact Details</p>
      </div>
      {/* First Name Field */}
      {renderInputField({
        id: "firstName",
        name: "firstName",
        label: "First Name",
        value: state.firstName,
        error: state.errors.firstName,
        required: true,
      })}

      {/* Last Name Field */}
      {renderInputField({
        id: "lastName",
        name: "lastName",
        label: "Last Name",
        value: state.lastName,
        error: state.errors.lastName,
        required: true,
      })}

      {/* Email Address Field */}
      {renderInputField({
        id: "email",
        name: "email",
        label: "Email Address",
        type: "email",
        value: state.email,
        error: state.errors.email,
        required: true,
      })}

      {/* Phone Number Field */}
      {renderInputField({
        id: "phoneNumber",
        name: "phoneNumber",
        label: "Phone Number",
        value: state.phoneNumber,
        error: state.errors.phoneNumber,
        required: true,
      })}
    </div>
  );
};

export default PersonalInfoFields;
